// extracted by mini-css-extract-plugin
export default {"bgPrimary":"Loading_bgPrimary__Tw+e2","contentLoder":"Loading_contentLoder__r-AqZ"};